import { portfolioConstants } from "actions/types";
import { camelCase, map } from "lodash";
import type { PortfoliosState } from "types/state";

interface PortfoliosAction {
  type: string;
  data?: unknown;
}

const initialState: PortfoliosState = {
  allPortfolios: [],
  otherPortfolios: [],
  recommendedPortfolio: {},
  activePortfolio: {},
  positions: [],
  positionsUpdatedAt: "",
  categoryPerformances: [],
  performanceUpdatedAt: "",
};

function formatPortfolio(portfolio: object) {
  return {
    ...portfolio,
    portfolioName: camelCase((portfolio as { label?: string }).label),
  };
}
export function portfolios(
  state: PortfoliosState = initialState,
  action: PortfoliosAction
): PortfoliosState {
  switch (action.type) {
    case portfolioConstants.GET_PORTFOLIOS_SUCCESS: {
      const data = action.data as { other?: object[]; recommended?: object };
      return {
        ...state,
        otherPortfolios: map(data.other, formatPortfolio),
        recommendedPortfolio: formatPortfolio(data.recommended as object),
      };
    }

    case portfolioConstants.GET_USER_PORTFOLIO_SUCCESS:
    case portfolioConstants.UPDATE_USER_PORTFOLIO_SUCCESS:
      return { ...state, activePortfolio: action.data as object | null };

    case portfolioConstants.GET_POSITIONS_SUCCESS: {
      const data = action.data as {
        positions?: unknown[];
        dateTime?: string;
      } | null;
      return {
        ...state,
        positions: data && data.positions,
        positionsUpdatedAt: data && data.dateTime,
      };
    }
    case portfolioConstants.GET_PERFORMANCE_SUCCESS: {
      const data = action.data as {
        categoryPerformances?: unknown[];
        updatedAt?: string;
      } | null;
      return {
        ...state,
        categoryPerformances: data && data.categoryPerformances,
        performanceUpdatedAt: data && data.updatedAt,
      };
    }
    default:
      return state;
  }
}
